// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../configs/app-info';

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Autocomplete,
    Fab,
    Typography,
    MenuItem
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import { getDoctag } from '../../../api/helper';
import { useToast } from '../../../components/ToastProvider';
import DialogDP from '../../../components/acc/DialogDP';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [tabs, setTabs] = useState<string>("0")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [doctag, setDoctag] = useState<any>(null)
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [listData, setListData] = useState<any[]>([])

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [dialogMode, setDialogMode] = useState<string>('add')
    const [selectedData, setSelectedData] = useState<any>(null)

    const [valDoctagSO, setValDoctagSO] = useState<any>(null)
    const [id, setId] = useState<any>(null)
    const [listDoctagSO, setListDoctagSO] = useState<any[]>([])

    const [openDialogAdd, setOpenDialogAdd] = useState<boolean>(false)

    useEffect(() => {
        getData(tabs)
        const fetchDoctag = async () => {
            let data = [{ id: null, nama: '-- Semua Document --' }];
            const response = await getDoctag(appInfo.menuId.quotation, cabang, token);
            data = data.concat(response);
            setListDoctag(data);
        };

        const fetchDoctagSO = async () => {
            const response = await getDoctag(appInfo.menuId.salesOrder, cabang, token);
            setListDoctagSO(response);
        };

        fetchDoctag();
        fetchDoctagSO();
    }, [])

    const navigate = useNavigate();

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setDoctag(newValue ? newValue.id : null)
        setValDoctag(newValue.nama)
    }

    const getData = (mode: any) => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        let url = apiUrl.apiUrl + '/sales/quotation/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    sysdoctag_id: doctag,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDetail = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setDialogMode('edit')
                    setSelectedData(data)
                    setOpenDialog(true)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/quotation/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/system/print/sdso/' + row.id, '_blank')
            },
            {
                title: "Hapus Quotation",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/sales/quotation/detail/' + id)}
                />
            ),
        },
    ];

    const convertComponent = [
        {
            key: 'dp_id',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.data.dp_id == null ? (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:file-document-plus" />}
                                onClick={() => {
                                    setDialogMode('add-from-list')
                                    setSelectedData(row.data)
                                    setOpenDialog(true)
                                }}
                            >
                                Buat DP
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:cash-fast" />}
                                onClick={() => {
                                    getDetail(row.data.dp_id)
                                }}
                            >
                                Bayar DP <br />
                                {row.data.dp_id}
                            </Button>
                        )}
                    </Box>
                )
            }
        },
        {
            key: 'preview',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                const documentNumber = row.data.preview?.split('/')[0] || row.data.preview;
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <div style={{ cursor: 'pointer' }} onClick={() => {
                            window.open(`/production/work-order/detail/${documentNumber}`, '_blank')
                        }}>
                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                {row.data.preview}
                            </Typography>
                        </div>
                    </Box>
                )
            }
        },
        {
            key: 'sales_order',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                const documentNumber = row.data.sales_order;
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.data.sales_order == null ? (
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:file-document-plus" />}
                                onClick={() => {
                                    setId(row.data.id)
                                    setValDoctagSO(null)
                                    setOpenDialogAdd(true)
                                }}
                            >
                                Buat Sales Order
                            </Button>
                        ) : (
                            <div style={{ cursor: 'pointer' }} onClick={() => {
                                window.open(`/sales/sales-order/detail/${documentNumber}`, '_blank')
                            }}>
                                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                    {row.data.sales_order}
                                </Typography>
                            </div>
                        )}
                    </Box>
                )
            }
        }
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='QUOTATION' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/sales/quotation/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData(tabs)}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Daftar Quotation' />
                            <Tab value='1' label='Quotation Belum Aktif' />
                        </TabList>
                        <TabPanel value='0'>
                            <MsiDatagrid array={listData} actions={actionData} customRender={convertComponent} hiddenColumns={['dokumen', 'sdcust_id', 'is_aktif', 'default_dp', 'default_dp_pesan']} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>

            <DialogDP
                key={selectedData?.id ?? 'add-from-list'}
                open={openDialog}
                mode={dialogMode}
                data={selectedData}
                doc_type={'sdso'}
                doc_id={selectedData?.id}
                onClose={() => {
                    setOpenDialog(false)
                    getData(tabs)
                }}
            />

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogAdd}
                onClose={() => setOpenDialogAdd(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Buat Sales Order
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3} component="form" onSubmit={(e) => {
                        e.preventDefault();
                        // Handle form submission

                        const payload = {
                            id_quotation: id,
                            sysdoctag_id: valDoctagSO
                        }
                        const url = apiUrl.apiUrl + '/sales/sales-order/add-so-from-quotation'
                        axios
                            .post(url, payload, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                            .then(response => {
                                if (response.data.success) {
                                    const data = response.data.data[0]

                                    showToast(response.data.message, 'success');
                                    navigate('/sales/sales-order/detail/' + data.id)
                                } else {
                                    showToast(response.data.message, 'error');
                                }
                            })
                            .catch(error => {
                                showToast(error.message, 'error');
                            })
                    }}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label='Pilih Doctag'
                                    value={valDoctagSO}
                                    onChange={(e) => setValDoctagSO(e.target.value)}
                                >
                                    <MenuItem value="" disabled>Pilih Doctag</MenuItem>
                                    {listDoctagSO.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.nama}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='contained' type='submit' disabled={!valDoctag} fullWidth>
                                Buat SO
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogAdd(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

        </Grid>
    )
}
